import { Auth } from "components/Parts/Organisms/Auth";
import { NotFoundPage } from "components/Parts/Organisms/NotFoundPage";
import React from "react";

export const NotFound = React.memo(() => (
  <Auth>
    <NotFoundPage />
  </Auth>
));
